import React from 'react';
import './DevisDetail.css';

const DevisDetail = ({ devis, onClose, onMarkAsRead, onUpdateStatus, onDelete }) => {
  const getStatusColor = (status) => {
    const colors = {
      pending: '#ff9800',
      contacted: '#2196f3',
      accepted: '#4caf50',
      rejected: '#f44336'
    };
    return colors[status] || '#666';
  };

  const getStatusLabel = (status) => {
    const labels = {
      pending: 'En attente',
      contacted: 'Contacté',
      accepted: 'Accepté',
      rejected: 'Rejeté'
    };
    return labels[status] || status;
  };

  const handleMarkAsRead = async () => {
    if (!devis.is_read && onMarkAsRead) {
      const result = await onMarkAsRead(devis.id);
      if (result.success) {
        // Optionally show a success message or refresh
      }
    }
  };

  const handleStatusChange = (e) => {
    if (onUpdateStatus) {
      onUpdateStatus(devis.id, e.target.value);
    }
  };

  if (!devis) return null;

  return (
    <div className="devis-detail-overlay" onClick={onClose}>
      <div className="devis-detail-modal" onClick={(e) => e.stopPropagation()}>
        <div className="devis-detail-header">
          <h2>Détails de la demande de devis</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>

        <div className="devis-detail-content">
          <div className="detail-section">
            <div className="detail-row">
              <div className="detail-item">
                <label>Nom complet</label>
                <p>{devis.prenom} {devis.nom}</p>
              </div>
              <div className="detail-item">
                <label>Statut</label>
                <span
                  className="status-badge-large"
                  style={{ backgroundColor: getStatusColor(devis.status) }}
                >
                  {getStatusLabel(devis.status)}
                </span>
              </div>
            </div>

            <div className="detail-row">
              <div className="detail-item">
                <label>Email</label>
                <p>
                  <a href={`mailto:${devis.email}`}>{devis.email}</a>
                </p>
              </div>
              <div className="detail-item">
                <label>Téléphone</label>
                <p>
                  <a href={`tel:${devis.telephone}`}>{devis.telephone}</a>
                </p>
              </div>
            </div>

            <div className="detail-item full-width">
              <label>Type de travaux</label>
              <p className="type-travaux">{devis.type_travaux}</p>
            </div>

            {devis.message && (
              <div className="detail-item full-width">
                <label>Message</label>
                <div className="message-box">
                  <p>{devis.message}</p>
                </div>
              </div>
            )}

            <div className="detail-row">
              <div className="detail-item">
                <label>Date de création</label>
                <p>{new Date(devis.created_at).toLocaleString('fr-FR')}</p>
              </div>
              <div className="detail-item">
                <label>Dernière mise à jour</label>
                <p>{new Date(devis.updated_at).toLocaleString('fr-FR')}</p>
              </div>
            </div>
          </div>

          <div className="detail-actions">
            <div className="status-select-container">
              <label htmlFor="status-select">Changer le statut</label>
              <select
                id="status-select"
                value={devis.status}
                onChange={handleStatusChange}
                className="status-select-large"
              >
                <option value="pending">En attente</option>
                <option value="contacted">Contacté</option>
                <option value="accepted">Accepté</option>
                <option value="rejected">Rejeté</option>
              </select>
            </div>

            <div className="action-buttons-group">
              {!devis.is_read && (
                <button
                  onClick={handleMarkAsRead}
                  className="mark-read-button"
                >
                  ✓ Marquer comme lu
                </button>
              )}
              
              {onDelete && (
                <button
                  onClick={() => {
                    onDelete(devis.id, `${devis.prenom} ${devis.nom}`);
                  }}
                  className="delete-button-modal"
                >
                  🗑️ Supprimer
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DevisDetail;

